// extracted by mini-css-extract-plugin
export default {"box_input":"InputApp_box_input__DffoB"};